module.exports = __webpack_public_path__ + "img/reg_icon_img.d1531042.png";